// Add security profile main router component.
// this Route consists of 3 other nested routes under/addProfile defined below
import React, { useEffect, useState } from "react";
import { BrowserRouter, Switch, Route, NavLink } from "react-router-dom";
import BasicSettings from "../../../../../Dashboard/Components/SecuritySettings/SecurityProfiles/EditProfile/BasicSettings";
import ACLmapping from "../../../../../Dashboard/Components/SecuritySettings/SecurityProfiles/EditProfile/ACLmapping";
import Nodes from "../../../../../Dashboard/Components/SecuritySettings/SecurityProfiles/EditProfile/Nodes";
import DesktopOnlyOverlay from "../../../../../Dashboard/Components/ShareElements/DesktopOnlyOverlay/DesktopOnlyOverlay";
import ContentHeader from "../../../../../Dashboard/Components/ShareElements/ContentHeader/ContentHeader";
import Circle from "../../../../../../Assets/Images/sm-Circle.svg";
import UnsavedChangesAlert from "../../../../../Dashboard/Components/ShareElements/UnsavedChangesAlert/UnsavedChangesAlert";

const EditSecurityProfileRoutes = (props) => {
  const [UnsavedChanges, setUnsavedChanges] = useState(false);
  const [NavIdClicked, setNavId] = useState("");

  useEffect(() => {
    window.localStorage.setItem("HasUnsaveChanges", 0);
    window.localStorage.setItem("HasValidationError", 0);
    window.localStorage.setItem("LastClickedId", "");
  }, []);

  const translateText = (LabelId) => {
    var Filter = "label_id";
    var Keyword = LabelId;
    var Label = props.LangData.filter((Obj) => {
      return Obj[Filter] === Keyword;
    });
    return Label[0].label_value;
  };

  const validateNavigation = (e, Id) => {
    window.localStorage.setItem("LastClickedId", Id);
    let UnsavedChangesStatus = parseInt(
      window.localStorage.getItem("HasUnsaveChanges")
    ); //true: 1, false: 0
    if (UnsavedChangesStatus === 0) {
      document.getElementById(Id).click();
      transformIndicator(Id); // gets the id and translates the indicator on the navigator
    } else if (UnsavedChangesStatus === 1) {
      e.preventDefault();
      setUnsavedChanges(true);
      setNavId(Id);
    }
  };

  const transformIndicator = (Id) => {
    if (Id === "acl-mapping") {
      document.getElementById("animated-indicator").style.transform =
        "translateX(134px)";
    } else if (Id === "basic-settings") {
      document.getElementById("animated-indicator").style.transform = "none";
    } else {
      document.getElementById("animated-indicator").style.transform =
        "translateX(269px)";
    }
  };

  const close = () => {
    setUnsavedChanges(false);
  };

  const discard = () => {
    setUnsavedChanges(false);
    window.localStorage.setItem("HasUnsaveChanges", 0);
    window.localStorage.removeItem("CreatedProfileId");
    window.localStorage.removeItem("CreatedProfileNameString");
    window.localStorage.removeItem("CreatedProfileDesc");
    window.localStorage.removeItem("MappingCreated");
    window.localStorage.removeItem("HasErrors");
    document.getElementById(NavIdClicked).click();
  };

  const saveAndLeave = () => {
    setUnsavedChanges(false);
    document.getElementById("save-btn").click();
    setTimeout(() => {
      if (window.localStorage.getItem("HasValidationError") === "1") {
        return null;
      } else {
        window.localStorage.setItem("HasUnsaveChanges", 0);
        console.log(window.localStorage.getItem("LastClickedId"));
        document
          .getElementById(window.localStorage.getItem("LastClickedId"))
          .click();
      }
    }, 1550);
  };

  return (
    <BrowserRouter basename="/home/securityProfiles/editProfile">
      {UnsavedChanges ? (
        <UnsavedChangesAlert
          close={() => close()}
          saveAndLeave={() => saveAndLeave()}
          discardAndLeave={() => discard()}
          LangData={props.LangData}
        />
      ) : null}
      <DesktopOnlyOverlay LangData={props.LangData} />
      <div className="main-content security-settings security-profiles">
        <ContentHeader PageName={translateText("security_profiles")} />
        <div className="content-header">
          <div className="address">
            <p>{translateText("security_settings")}</p>
            <img src={Circle} alt="." />
            <p>{translateText("security_profiles")}</p>
            <img src={Circle} alt="." />
            <p>{translateText("edit_profile")}</p>
          </div>
        </div>
        <div className="actions navigator">
          <span id="animated-indicator"></span>
          <NavLink
            onClick={(e) => validateNavigation(e, "basic-settings")}
            activeClassName="active-nav-node"
            exact
            id="basic-settings"
            to="/"
          >
            <p>{translateText("basic_settings")}</p>
          </NavLink>
          <NavLink
            onClick={(e) => validateNavigation(e, "acl-mapping")}
            activeClassName="active-nav-node"
            to="/ACLmapping"
            id="acl-mapping"
          >
            <p>{translateText("acl_mapping")}</p>
          </NavLink>
          <NavLink
            onClick={(e) => validateNavigation(e, "nodes")}
            activeClassName="active-nav-node"
            id="nodes"
            to="/nodes"
          >
            <p>{translateText("nodes")}</p>
          </NavLink>
        </div>
        <Switch>
          <Route path="/ACLmapping" exact>
            <ACLmapping LangData={props.LangData} />
          </Route>
          <Route path="/nodes" exact>
            <Nodes LangData={props.LangData} />
          </Route>
          <Route path="/" exact>
            <BasicSettings LangData={props.LangData} />
          </Route>
        </Switch>
      </div>
    </BrowserRouter>
  );
};

export default EditSecurityProfileRoutes;
